/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const digipost_medium = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#000"
      d="M3.75 4.5V2c0-.966.784-1.75 1.75-1.75h10.036a1.75 1.75 0 0 1 1.336.62l4.964 5.866c.267.316.414.716.414 1.13V22a1.75 1.75 0 0 1-1.75 1.75h-15A1.75 1.75 0 0 1 3.75 22v-2.5a.75.75 0 0 1 1.5 0V22c0 .138.112.25.25.25h15a.25.25 0 0 0 .25-.25V7.866a.25.25 0 0 0-.06-.16l-4.963-5.867a.25.25 0 0 0-.19-.089H5.5a.25.25 0 0 0-.25.25v2.5a.75.75 0 0 1-1.5 0Z"
    />
    <path
      fill="#000"
      d="M8.784 5.8V17H7.136v-1.392a3.102 3.102 0 0 1-1.168 1.152c-.47.256-1.008.384-1.616.384a3.61 3.61 0 0 1-1.92-.528 3.864 3.864 0 0 1-1.344-1.488A4.566 4.566 0 0 1 .592 13c0-.779.165-1.483.496-2.112.33-.64.779-1.136 1.344-1.488a3.53 3.53 0 0 1 1.92-.544 3.28 3.28 0 0 1 1.456.32c.448.203.821.501 1.12.896V5.8h1.856Zm-4.16 9.84c.672 0 1.221-.245 1.648-.736.437-.501.656-1.136.656-1.904s-.219-1.397-.656-1.888c-.427-.501-.976-.752-1.648-.752-.63 0-1.147.25-1.552.752-.405.49-.608 1.12-.608 1.888 0 .768.197 1.403.592 1.904.405.49.928.736 1.568.736Z"
    />
  </svg>
)
export default digipost_medium
